import { render, staticRenderFns } from "./group-dashboards-grid.vue?vue&type=template&id=b18c12fc&"
import script from "./group-dashboards-grid.vue?vue&type=script&lang=js&"
export * from "./group-dashboards-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports